module.exports = __webpack_public_path__ + "img/icon-change-cam.aefc1999.svg";